import React from 'react';
import { COST_CENTER_TYPE_OPTIONS, COST_CENTER_TYPE_COLORS, STATUS } from '../../../core/constants/financial';

const getTypeTag = (type) => {
  const colors = COST_CENTER_TYPE_COLORS[type] || {};
  const label = COST_CENTER_TYPE_OPTIONS.find((o) => o.value === type)?.label || type || '—';
  return (
    <span
      className="fd-type-tag"
      style={{ background: colors.bg, color: colors.color, borderColor: colors.border }}
    >
      {label}
    </span>
  );
};

const CostCenterTable = ({ costCenters, onEdit, totalRateio }) => (
  <>
    <div className="fd-modal-table-wrapper">
      <table className="fd-modal-table fd-modal-table--clickable">
        <thead>
          <tr>
            <th style={{ width: 60 }}>Cód.</th>
            <th>Nome</th>
            <th style={{ width: 130 }}>Tipo</th>
            <th style={{ width: 130 }}>Responsável</th>
            <th style={{ width: 100, textAlign: 'right' }}>% Rateio</th>
            <th style={{ width: 80, textAlign: 'center' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {costCenters.map((cc) => {
            const isInactive = cc.status === STATUS.INATIVO;
            return (
              <tr
                key={cc.id}
                onClick={() => onEdit(cc)}
                title="Clique para editar"
                style={{ opacity: isInactive ? 0.45 : 1 }}
              >
                <td style={{ fontFamily: "'Rajdhani', sans-serif", fontWeight: 700, color: '#ccc' }}>
                  {cc.code}
                </td>
                <td>
                  <div style={{ fontWeight: 600 }}>{cc.name}</div>
                  {cc.description && <div style={{ fontSize: 10, marginTop: 2, color: '#777' }}>{cc.description}</div>}
                </td>
                <td>{getTypeTag(cc.type)}</td>
                <td className="fd-table-muted">{cc.responsible || '—'}</td>
                <td style={{ textAlign: 'right' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'flex-end' }}>
                    <div style={{ flex: 1, maxWidth: 70, height: 4, background: '#383838', borderRadius: 2, overflow: 'hidden' }}>
                      <div style={{
                        height: '100%',
                        width: `${Math.min(cc.percentage || 0, 100)}%`,
                        background: cc.percentage > 0 ? '#e88c2a' : '#383838',
                        borderRadius: 2,
                        transition: 'width 0.3s',
                      }} />
                    </div>
                    <span style={{
                      fontFamily: "'Rajdhani', sans-serif",
                      fontSize: 13,
                      fontWeight: 700,
                      color: cc.percentage > 0 ? '#e88c2a' : '#666',
                      minWidth: 38,
                      textAlign: 'right',
                    }}>
                      {cc.percentage != null ? `${cc.percentage}%` : '—'}
                    </span>
                  </div>
                </td>
                <td style={{ textAlign: 'center' }}>
                  <span className={`fd-status-badge fd-status-badge--${cc.status || 'ativo'}`}>
                    {cc.status === STATUS.INATIVO ? 'Inativo' : 'Ativo'}
                  </span>
                </td>
              </tr>
            );
          })}
          {costCenters.length === 0 && (
            <tr>
              <td colSpan={6} className="fd-table-empty">Nenhum centro de custo encontrado</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

    {/* FOOTER RATEIO */}
    <div className="fd-modal-footer" style={{ justifyContent: 'flex-end', gap: 12 }}>
      <span style={{ fontSize: 11, color: '#999' }}>Total de rateio dos ativos:</span>
      <span style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 16, fontWeight: 700, color: totalRateio === 100 ? '#70E000' : '#fff' }}>
        {totalRateio}%
      </span>
      {totalRateio !== 100 && (
        <span style={{
          background: 'rgba(232,140,42,0.15)',
          color: '#e88c2a',
          border: '1px solid rgba(232,140,42,0.35)',
          padding: '2px 10px',
          borderRadius: 3,
          fontSize: 10,
          fontWeight: 700,
        }}>
          ≠ 100%
        </span>
      )}
    </div>
  </>
);

export default CostCenterTable;
